import { define } from '../../define.js';
import { InputGroup } from './input-group.js';
export * from './input-group.js';
define('input-group', InputGroup);
